export default function showToast(message, type = 'success', duration = 7000) {
    
    // Dismiss any existing toast to avoid overlap (animate out then remove)
    const existingToast = document.querySelector('.toast');
    if (existingToast) {
        try {
            existingToast.style.transform = 'translateX(120%)';
            existingToast.style.opacity = '0';
            setTimeout(() => {
                if (existingToast.parentNode) {
                    existingToast.parentNode.removeChild(existingToast);
                }
            }, 300);
        } catch (e) {
            if (existingToast.parentNode) existingToast.parentNode.removeChild(existingToast);
        }
    }
    
    // Create toast element
    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.style.cssText = `
        position: fixed !important;
        bottom: 30px !important;
        right: 30px !important;
        z-index: 999999 !important;
        display: flex !important;
        align-items: center;
        gap: 12px;
        min-width: 300px;
        max-width: 500px;
        padding: 17px 24px;
        border-radius: 10px;
        color: #fff !important;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
        font-size: 16px !important;
        line-height: 20px;
        opacity: 0;
        transform: translateX(120%);
        transition: transform 0.5s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.4s ease;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
        pointer-events: auto !important;
    `;

    // Set background based on type
    const backgrounds = {
        success: 'linear-gradient(90deg, #1bbd36 0%, #28a745 100%)',
        error: 'linear-gradient(90deg, #e53935 0%, #dc3545 100%)',
        info: 'linear-gradient(90deg, #1e90ff 0%, #238ef8 100%)',
        warning: 'linear-gradient(90deg, #f7b733 0%, #f57c00 100%)'
    };
    toast.style.background = backgrounds[type] || backgrounds.success;

    // Provide icon based on type
    const icons = {
        success: '✅',
        error: '❌',
        info: 'ℹ️',
        warning: '⚠️'
    };

    toast.innerHTML = `
        <span class="toast-icon" style="font-size: 20px; line-height: 1; flex-shrink: 0;">${icons[type] || '🔔'}</span>
        <span class="toast-message" style="flex: 1; word-wrap: break-word;">${message}</span>
    `;

    // Append to body
    document.body.appendChild(toast);

    // Trigger reflow for transition
    setTimeout(() => {
        toast.style.transform = 'translateX(0)';
        toast.style.opacity = '1';
    }, 100);

    // Hide after duration
    setTimeout(() => {
        toast.style.transform = 'translateX(120%)';
        toast.style.opacity = '0';
        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
        }, 500);
    }, duration);
}
